<template>
  <header class="flex items-center justify-between py-4 px-4">
    <div class="flex items-center space-x-4">
      <div class="h-11 w-11 bg-primary text-center flex justify-center items-center">
        <span class="font-bold text-xl">LS</span>
      </div>
      <div id="header-title" class="font-medium text-xl"></div>
    </div>
    <div id="header-actions" class="flex space-x-4"></div>
  </header>
  <div id="header-progress-bar"></div>
  <main class="flex-1 flex flex-col overflow-auto">
    <slot></slot>
  </main>
  <DevOptions v-if="env?.DEV"></DevOptions>
</template>

<script setup lang="ts">
import DevOptions from '@/questionnaire/components/DevOptions.vue'

import { useLsGeneralStore } from '@/questionnaire/stores/application'
const { env } = useLsGeneralStore()
</script>
